var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSelection)?_c('div',{staticClass:"pill-wrapper"},[_c('b-button',{staticClass:"pill"},[_vm._v(_vm._s(_vm.selectedLabel))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }